/*
  Cart drawer swag upsell: add-to-cart handling.
  Works with snippets/cart-upsell-swag.liquid. Uses document-level event delegation so it keeps
  working after Dawn re-renders the drawer HTML (inline scripts inside re-rendered HTML do not run).
  Added 2026-09. AP
*/
(function () {
  if (window.SLCartUpsellReady) return;
  window.SLCartUpsellReady = true;

  document.addEventListener('click', function (evt) {
    const button = evt.target.closest('.cart-upsell__add');
    if (!button || button.getAttribute('aria-disabled') === 'true') return;

    const item = button.closest('.cart-upsell__item');
    if (!item) return;

    const select = item.querySelector('.cart-upsell__variant');
    const variantId = select ? select.value : button.dataset.variantId;
    const error = item.querySelector('.cart-upsell__error');

    if (!variantId) {
      showError(error, select ? 'Please choose a ' + (select.getAttribute('aria-label') || 'size').toLowerCase() : 'Unavailable');
      if (select) select.focus();
      return;
    }

    addToCart(button, item, variantId, error);
  });

  function showError(el, message) {
    if (!el) return;
    el.textContent = message;
    el.hidden = false;
  }

  function addToCart(button, item, variantId, error) {
    const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const spinner = button.querySelector('.loading__spinner');

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    if (error) error.hidden = true;

    const properties = {};
    // Mirror what buy-buttons.liquid stamps on swag lines so reporting stays consistent.
    if (item.dataset.program) properties['Program'] = item.dataset.program;

    const body = { id: Number(variantId), quantity: 1, properties: properties };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map((section) => section.id).join(',');
      body.sections_url = window.location.pathname;
    }

    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(body);

    fetch(window.routes.cart_add_url, config)
      .then((response) => response.json())
      .then((response) => {
        if (response.status) {
          showError(error, response.description || response.message || 'Could not add to cart');
          publish(PUB_SUB_EVENTS.cartError, {
            source: 'cart-upsell',
            productVariantId: variantId,
            errors: response.errors || response.description,
            message: response.message,
          });
          return;
        }

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-upsell',
          productVariantId: variantId,
          cartData: response,
        });

        // CR 9.26: adding from an empty cart left the outer <cart-drawer> tagged "is-empty",
        // which left the drawer rendering blank/white after the swap. Dawn's stock
        // product-form.js clears this before renderContents(); this add button needs the
        // same step since it bypasses that file entirely.
        if (cart && cart.classList.contains('is-empty')) {
          cart.classList.remove('is-empty');
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else {
          window.location = window.routes.cart_url;
        }
      })
      .catch((e) => {
        console.error('cart-upsell add failed', e);
        showError(error, 'Something went wrong. Please try again.');
      })
      .finally(() => {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        if (spinner) spinner.classList.add('hidden');
      });
  }
})();